import NitroFilter from "../NitroFilter";

const modes = ["TRUCK", "RAIL", "BARGE", "PIPELINE", "VESSEL"];

const ModeFilter = ({
  value,
  setValue,
  type,
  isMobile,
  disabled,
}: {
  value: string;
  setValue: (value: string) => void;
  type?: "popup" | "autocomplete";
  isMobile?: boolean;
  disabled?: boolean;
}) => {
  return (
    <NitroFilter
      value={value}
      setValue={setValue}
      placeholder="Mode"
      data={{
        options: modes.map((mode) => {
          return { label: mode, value: mode };
        }),
      }}
      isMobile={isMobile}
      type={type}
      disabled={disabled}
    />
  );
};

export default ModeFilter;
